import React from 'react'
import { render } from 'react-dom'
import App from 'App'
import registerServiceWorker from './registerServiceWorker'
import 'babel-polyfill'

import { store, history, persistor } from './redux'
import * as Sentry from '@sentry/browser'

const match = /(_token=)([A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*)|(code=)([A-Za-z0-9-]+)/g

Sentry.init({
  beforeSend: event => {
    if (event.request && event.request.url) {
      event.request.url = event.request.url.replace(match, '$1[filtered]')
    }
    return event
  },
  beforeBreadcrumb: (breadcrumb, hint) => {
    if (breadcrumb.category === 'navigation') {
      if (breadcrumb.data.to) {
        breadcrumb.data.to = breadcrumb.data.to.replace(match, '$1[filtered]')
      }
      if (breadcrumb.data.from) {
        breadcrumb.data.from = breadcrumb.data.from.replace(
          match,
          '$1[filtered]'
        )
      }
    }
    return breadcrumb
  },
  environment: `tenants.${process.env.REACT_APP_ENVIRONMENT}.${process.env.REACT_APP_TENANT_ID}`,
  dsn: 'https://0ca83c8de7ed4175968d793999cbf782@sentry.io/1849338'
})

render(
  <App store={store} history={history} persistor={persistor} />,
  document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js